"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("composer-lib/lib/constants");

var _utils = require("composer-lib/components/clips/utils");

var colors = _interopRequireWildcard(require("HubStyleTokens/colors"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _default = (0, _createReactClass.default)({
  displayName: "AttributionDeleteButton",
  propTypes: {
    closePopover: _propTypes.default.func.isRequired,
    isCollectBeta: _propTypes.default.bool,
    openPopover: _propTypes.default.bool.isRequired,
    togglePopover: _propTypes.default.func.isRequired,
    updateAttribution: _propTypes.default.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      termsAccepted: false
    };
  },
  toggleTermsAccepted: function toggleTermsAccepted() {
    this.setState(function (prevState) {
      return {
        termsAccepted: !prevState.termsAccepted
      };
    });
  },
  deleteAttribution: function deleteAttribution() {
    (0, _UsageTracking.trackEvent)({
      action: 'manage-collect',
      extra: {
        'manage-collect': 'delete-attribution'
      },
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.USAGE
    });
    this.props.updateAttribution(null);
  },
  renderTermsAndConditionsCheckbox: function renderTermsAndConditionsCheckbox() {
    var termsAccepted = this.state.termsAccepted;
    var options = {
      closeLink: _I18n.default.SafeString('</a>'),
      openLink: _I18n.default.SafeString("<a href=\"" + _constants.TERMS_AND_CONDITIONS_URL + "\" target=\"_blank\">")
    };
    return _react.default.createElement(_UICheckbox.default, {
      checked: termsAccepted,
      className: "attribution-checkbox",
      onChange: this.toggleTermsAccepted
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: (0, _utils.clipsLangKey)('attribution.terms'),
      options: options
    }));
  },
  renderPopoverContent: function renderPopoverContent() {
    var closePopover = this.props.closePopover;
    var termsAccepted = this.state.termsAccepted;
    return {
      header: _react.default.createElement("h4", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.delete.header')
      })),
      body: _react.default.createElement("span", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.delete.body')
      }), this.renderTermsAndConditionsCheckbox()),
      footer: _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
        disabled: !termsAccepted,
        onClick: this.deleteAttribution,
        use: "danger"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.delete.button.remove')
      })), _react.default.createElement(_UIButton.default, {
        onClick: closePopover,
        use: "tertiary-light"
      }, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: (0, _utils.clipsLangKey)('attribution.delete.button.cancel')
      })))
    };
  },
  renderDeleteButton: function renderDeleteButton(onClick) {
    return _react.default.createElement(_UIIcon.default, {
      className: "pointer",
      color: colors.ALERT_DANGER,
      onClick: onClick,
      name: "delete"
    });
  },
  render: function render() {
    var _this$props = this.props,
        isCollectBeta = _this$props.isCollectBeta,
        openPopover = _this$props.openPopover,
        togglePopover = _this$props.togglePopover;

    if (isCollectBeta) {
      return this.renderDeleteButton(this.deleteAttribution);
    }

    return _react.default.createElement(_UIPopover.default, {
      content: this.renderPopoverContent(),
      open: openPopover,
      use: "shepherd",
      width: 350
    }, this.renderDeleteButton(togglePopover));
  }
});

exports.default = _default;
module.exports = exports.default;